import React from 'react';
import { ACCENT_COLOR } from './colors';

const Add = ({
  width = 24,
  className = '',
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M7 12H17" stroke={ACCENT_COLOR} strokeWidth="2" />
    <path d="M12 7L12 17" stroke={ACCENT_COLOR} strokeWidth="2" />
    <circle cx="12" cy="12" r="9" stroke="#333333" strokeWidth="2" />
  </svg>
);

export default Add;
